import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import React, { useContext } from 'react';
export var DraftailContext = React.createContext({});
export var useDraftailComponents = function useDraftailComponents(components) {
  var contextComponents = useContext(DraftailContext);
  var allComponents = contextComponents;
  if (components) {
    if (typeof components === 'function') {
      allComponents = components(contextComponents);
    } else {
      allComponents = _objectSpread({}, contextComponents, {}, components);
    }
  }
  return allComponents;
};
export default function DraftailProvider(props) {
  var allComponents = useDraftailComponents(props.components);
  return /*#__PURE__*/React.createElement(DraftailContext.Provider, {
    value: allComponents
  }, props.children);
}